import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../shell/PageHeader';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import StockMovementsTable from '../inventory/StockMovementsTable';

const ConsumableStockMovementsPage: React.FC = () => {
  const { t } = useTranslation();

  useBreadcrumb([
    { label: 'Citrus Synch', to: '/' },
    { label: t('consumables.title'), to: '/consumables/catalog' },
    { label: t('consumables.stockMovements.title') },
  ]);

  return (
    <div data-testid="consumables-stock-movements-page">
      <PageHeader
        title={t('consumables.stockMovements.title')}
        meta={t('consumables.stockMovements.meta')}
      />
      <StockMovementsTable />
    </div>
  );
};

export default ConsumableStockMovementsPage;
